var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.2002 9.99374V12.2886C3.2002 12.6364 3.32662 12.9699 3.55167 13.2158C3.77671 13.4617 4.08194 13.5999 4.4002 13.5999H11.6002C11.9185 13.5999 12.2237 13.4617 12.4487 13.2158C12.6738 12.9699 12.8002 12.6364 12.8002 12.2886V9.99374M8.00076 2.3999L8.00076 9.83079M8.00076 9.83079L5.2579 6.99148M8.00076 9.83079L10.7436 6.99148",
    stroke: "#33363F",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.dc44b132570b01a11971e94e7353a6ed.svg";
export { ForwardRef as ReactComponent };